/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {AdnCountrySelectComponent} from './adn-country-select.component';
import {CountrySelectComponent} from './country-select';

const COUNTRY_SELECTS = [
  CountrySelectComponent,
  AdnCountrySelectComponent
];

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: COUNTRY_SELECTS,
  exports: COUNTRY_SELECTS
})
export class CountrySelectModule {
}
